import { CrownFilled } from "@ant-design/icons";
import mergeClassNames from "common/mergeClassNames";

interface IGoldenNominalBadgeProps {
    // "GOLDEN NOMINAL" in lists / dataset detail; "GOLDEN" where space is tight (e.g. search).
    label?: string;
    className?: string;
    // "SURVIVES" variant used in the dedup cluster view.
    tone?: "gold" | "subordinate";
}

// Shared marker for the Golden Nominal dataset (and its records). Crown + gold pill,
// matching the nomination visuals across dataset lists, search and dedup.
export default function GoldenNominalBadge({ label = "GOLDEN NOMINAL", className, tone = "gold" }: IGoldenNominalBadgeProps) {
    if (tone === "subordinate") {
        return (
            <span
                className={mergeClassNames(
                    "inline-flex items-center rounded-full border border-gray-200 bg-gray-100 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide text-gray-500",
                    className,
                )}
                data-testid="golden-nominal-badge-subordinate"
            >
                {label}
            </span>
        );
    }
    return (
        <span
            className={mergeClassNames(
                "inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-100 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-amber-800",
                className,
            )}
            data-testid="golden-nominal-badge"
        >
            <CrownFilled className="text-amber-500" />
            {label}
        </span>
    );
}
